export enum CHARACTER_INFO_PROFILE_BUTTON_TYPE {
    twitter = 'twitter',
    portfolio = 'portfolio',
    mail = 'mail',
}
